.vs-quiz-border {
  border: 1px solid var(--primary-color);
  border-radius: 3px;
  background: #fff;
  height: 2rem;
  width: 99px;
}

.vs-quiz-heading {
  font-size: 21px !important;
  line-height: 28px !important;
}
